import type { RemediationMode, RemediationStep } from '@evi/shared';

/** The remediation ladder's action rows in plain words, for the Admin log and the charger card (pure, no Api). */
interface ActionLike { step: RemediationStep; mode: RemediationMode; command: string | null; payload: Record<string, unknown> | null; outcome: string; trigger: string }

/** One action in plain words: "Soft reset (shadow): would have sent", "Connector 2 Inoperative: accepted". */
export function actionLine(a: ActionLike, labels: Record<RemediationStep, string>): string {
  const connector = typeof a.payload?.['connectorId'] === 'number' ? ` ${String(a.payload['connectorId'])}` : '';
  const what = a.step === 'a' ? `Asked for ${String(a.payload?.['requestedMessage'] ?? 'a report')}${connector}`
    : a.step === 'b1' ? `${a.trigger === 'restore' ? 'Put back in service' : `Connector${connector} ${String(a.payload?.['type'] ?? '')}`}`.trim()
      : labels[a.step];
  const outcome = a.outcome.startsWith('skipped:') ? `held back (${a.outcome.slice(8).replace(/_/g, ' ')})` : a.outcome.replace(/_/g, ' ');
  return `${what}${a.mode === 'shadow' ? ' (shadow)' : ''}: ${outcome}`;
}
